module.exports = __webpack_public_path__ + "img/vsp0.b7a7f3ba.gif";